import { GetHealthSubPlans } from 'domain/usecases/patient/get-health-sub-plans'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteGetHealthSubPlans implements GetHealthSubPlans {
  constructor(private readonly patientNewRepository: PatientNewRepository) {}

  get(params: GetHealthSubPlans.Params): Promise<GetHealthSubPlans.Model> {
    return this.patientNewRepository.getHealthSubPlans(params)
  }
}
